import { useRegisterSW } from "virtual:pwa-register/react";

const DEPLOY_RECOVERY_KEY = "foreducator:deploy-recovery";

async function recoverFromBrokenServiceWorker(): Promise<void> {
  if (sessionStorage.getItem(DEPLOY_RECOVERY_KEY)) return;
  sessionStorage.setItem(DEPLOY_RECOVERY_KEY, "1");
  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((registration) => registration.unregister()));
  } catch {
    // unregister 실패해도 새로고침으로 최신 HTML/청크를 받도록 시도
  }
  window.location.reload();
}

function watchInstallingWorker(worker: ServiceWorker): void {
  const installTimeoutMs = 30_000;
  const timeoutId = window.setTimeout(() => {
    if (worker.state === "installing") {
      void recoverFromBrokenServiceWorker();
    }
  }, installTimeoutMs);

  worker.addEventListener("statechange", () => {
    if (worker.state === "activated" || worker.state === "redundant") {
      window.clearTimeout(timeoutId);
    }
  });
}

export function PWAUpdatePrompt() {
  useRegisterSW({
    immediate: true,
    onRegisteredSW(_swUrl, registration) {
      if (!registration) return;

      registration.addEventListener("updatefound", () => {
        const installing = registration.installing;
        if (installing) watchInstallingWorker(installing);
      });

      const intervalMs = 5 * 60 * 1000;
      setInterval(() => {
        registration.update().catch(() => {
          // 네트워크 일시 오류는 다음 주기에 재시도
        });
      }, intervalMs);
    },
    onNeedRefresh() {
      window.location.reload();
    },
    onRegisterError() {
      void recoverFromBrokenServiceWorker();
    },
  });

  return null;
}
